"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
export default function Projects() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const topics = [{
    title: "İmplant Nedir?",
    content: "İmplant, eksik dişin yerine çene kemiğine yerleştirilen titanyum vida üzerine yapılan sabit diştir. Kayseri’de implant tedavisi, doğal dişe en yakın sonuçları sunar ve uzun yıllar güvenle kullanılabilir."
  }, {
    title: "Kimler Yaptırabilir?",
    content: "Tek diş eksikliği olanlar, birden fazla diş kaybı yaşayanlar, tam dişsiz hastalar ve protez kullanmak istemeyenler için uygundur. Kayseri Diş Kliniğimiz'de öncesinde detaylı muayene ile kişiye özel planlama yapılır."
  }, {
    title: "Tedavi Süreci",
    content: "Kayseri'de implant tedavisi süreci; muayene ve röntgen, implantın yerleştirilmesi, 2-3 aylık iyileşme süreci ve son olarak kalıcı dişin takılması aşamalarından oluşur. İşlemler steril ve konforlu şartlarda yapılır."
  }, {
    title: "Ağrı ve Konfor",
    content: "Kayseri'de hastaların en çok merak ettiği konu \"implant acıtır mı?\". İşlem sırasında ağrı hissedilmez. Sonrasında hassasiyet olabilir; genellikle 3-7 gün içinde rahatlama sağlanır. Hastalarımızın konforu en büyük önceliğimizdir."
  }, {
    title: "Kayseri İmplant Fiyatları 2026",
    content: "Kayseri implant fiyatları; marka seçimi, kemik durumu, ek cerrahi işlemler ve yapılacak implant sayısına göre değişir. Net bilgi için muayene gereklidir. 2026 Yılı Kayseri implant fiyatları hakkında detaylı bilgi almak için sizi kliniğimize bekliyoruz."
  }, {
    title: "Neden Bizi Seçmelisiniz?",
    content: "Kayseri'de merkezi konumdaki modern kliniğimizde, güncel teknoloji ve hasta memnuniyeti odaklı yaklaşımımızla estetik ve fonksiyonel sonuçlar sunuyoruz."
  }];
  return <section data-section-id="184775" id="kayseri-implant-tedavisi" className="relative bg-linear-to-b from-background to-secondary/20 py-32 md:py-48 lg:py-56 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        <div ref={headerRef} className={`flex flex-col items-center text-center max-w-4xl mx-auto mb-20 md:mb-32 transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="font-sans text-xs md:text-sm font-semibold tracking-widest uppercase text-primary mb-6">
            Öne Çıkan Tedavilerimiz
          </span>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-8xl text-foreground leading-tight tracking-tight">
            Kayseri İmplant Tedavisi
          </h2>
          <Separator className="w-24 bg-primary/40 mt-10" />
        </div>

        <div className={`transition-all duration-1000 delay-300 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <p className="max-w-3xl mx-auto text-center font-sans text-lg md:text-xl text-muted-foreground leading-relaxed mb-16 md:mb-24">
            Kayseri’de eksik dişleriniz için kalıcı, estetik ve konforlu bir çözüm arıyorsanız implant tedavisi en etkili yöntemdir. Doğal dişe en yakın sonuçları sunan bu tedavi, modern kliniğimizde uzmanlıkla uygulanmaktadır.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
            {topics.map((topic, i) => <Card key={i} data-index={i} className="group bg-card/50 backdrop-blur-sm border-none shadow-sm hover:shadow-md hover:bg-secondary/30 transition-all duration-500">
                <CardHeader className="pb-4">
                  <CardTitle className="font-serif text-2xl md:text-3xl text-foreground group-hover:text-primary transition-colors duration-300">
                    {topic.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-muted-foreground leading-relaxed">
                    {topic.content}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>

      </div>
    </section>;
}